/**
 * SPM Bundled Products — animated accordion
 * Animates <details class="spm-bundle-item"> open/close using WAAPI,
 * measuring real pixel heights so it works without knowing content height in advance.
 */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function enforceConsistentQtyLayout(container) {
    container.classList.remove('spm-bundled-products--stacked-qty');

    var wrapped = false;
    container.querySelectorAll('.spm-bundle-item__title-row').forEach(function (row) {
      var title = row.querySelector('.spm-bundle-item__title');
      if (title && row.offsetHeight > title.offsetHeight * 1.5) {
        wrapped = true;
      }
    });

    if (wrapped) {
      container.classList.add('spm-bundled-products--stacked-qty');
    }
  }

  function SpmBundleAccordion(detailsEl, group) {
    this.details = detailsEl;
    this.summary = detailsEl.querySelector('summary');
    this.content = detailsEl.querySelector('.spm-bundle-item__full');
    this.group = group;
    this.runningAnimation = null;
    this.contentAnimation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (!this.summary || !this.content) return;

    this.measure();

    // The up-chevron lives inside the description, which is a sibling of
    // <summary>, not a descendant — so it needs its own click handler rather
    // than relying on the row's click bubbling up to summary.
    var chevronUp = this.details.querySelector('.spm-bundle-item__chevron--up');
    if (chevronUp) {
      chevronUp.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          if (prefersReducedMotion) {
            this.details.open = false;
          } else {
            this.details.style.overflow = 'hidden';
            this.collapse();
          }
        }.bind(this)
      );
    }

    this.summary.addEventListener('click', this.handleClick.bind(this));
  }

  SpmBundleAccordion.prototype.measure = function () {
    // Cache the true closed-state height now. If the item happens to be open
    // (e.g. re-measuring after a resize), briefly reveal the teaser to get an
    // accurate reading, since it's normally hidden while open.
    var wasOpen = this.details.open;
    if (wasOpen) this.details.classList.add('spm-bundle-item--measuring');

    this.closedHeight = this.summary.offsetHeight;

    // Pin the expanded description to start exactly where the teaser began,
    // regardless of how tall the row is (e.g. a tall thumbnail shouldn't push it down).
    var teaser = this.details.querySelector('.spm-bundle-item__teaser');
    this.contentTop = 0;
    if (teaser) {
      var detailsRect = this.details.getBoundingClientRect();
      var teaserRect = teaser.getBoundingClientRect();
      this.contentTop = teaserRect.top - detailsRect.top;
      this.content.style.top = this.contentTop + 'px';
    }

    if (wasOpen) this.details.classList.remove('spm-bundle-item--measuring');
  };

  SpmBundleAccordion.prototype.handleClick = function (event) {
    event.preventDefault();

    if (prefersReducedMotion) {
      this.details.open = !this.details.open;
      return;
    }

    this.details.style.overflow = 'hidden';

    if (this.isClosing || !this.details.open) {
      this.expand();
    } else if (this.isExpanding || this.details.open) {
      this.collapse();
    }
  };

  SpmBundleAccordion.prototype.collapse = function () {
    this.isClosing = true;

    var startHeight = this.details.offsetHeight + 'px';
    var endHeight = this.closedHeight + 'px';

    if (this.runningAnimation) this.runningAnimation.cancel();
    if (this.contentAnimation) this.contentAnimation.cancel();

    this.runningAnimation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: 250, easing: 'ease-out' }
    );

    this.contentAnimation = this.content.animate(
      [
        { opacity: 1, offset: 0 },
        { opacity: 0, offset: 0.5 },
        { opacity: 0, offset: 1 }
      ],
      { duration: 250, easing: 'ease-out' }
    );

    this.runningAnimation.onfinish = this.onAnimationDone.bind(this, false);
    this.runningAnimation.oncancel = function () {
      this.isClosing = false;
    }.bind(this);
  };

  SpmBundleAccordion.prototype.expand = function () {
    var self = this;

    if (this.group) {
      this.group.forEach(function (other) {
        if (other !== self && (other.details.open || other.isExpanding)) {
          other.collapse();
        }
      });
    }

    this.details.style.height = this.details.offsetHeight + 'px';
    this.details.open = true;

    window.requestAnimationFrame(
      function () {
        this.isExpanding = true;

        var startHeight = this.details.offsetHeight + 'px';
        var contentBottom = this.contentTop + this.content.offsetHeight;
        var endHeight = Math.max(this.summary.offsetHeight, contentBottom) + 'px';

        if (this.runningAnimation) this.runningAnimation.cancel();
        if (this.contentAnimation) this.contentAnimation.cancel();

        this.runningAnimation = this.details.animate(
          { height: [startHeight, endHeight] },
          { duration: 250, easing: 'ease-out' }
        );

        this.contentAnimation = this.content.animate(
          [
            { opacity: 0, offset: 0 },
            { opacity: 0, offset: 0.5 },
            { opacity: 1, offset: 1 }
          ],
          { duration: 250, easing: 'ease-out' }
        );

        this.runningAnimation.onfinish = this.onAnimationDone.bind(this, true);
        this.runningAnimation.oncancel = function () {
          this.isExpanding = false;
        }.bind(this);
      }.bind(this)
    );
  };

  SpmBundleAccordion.prototype.onAnimationDone = function (isOpen) {
    this.details.open = isOpen;
    this.runningAnimation = null;
    this.contentAnimation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (isOpen) {
      // The description is absolutely positioned, so it no longer contributes
      // to the details element's natural flow height — an explicit height must
      // persist while open, rather than reverting to auto/natural height.
      var openHeight = Math.max(this.summary.offsetHeight, this.contentTop + this.content.offsetHeight);
      this.details.style.height = openHeight + 'px';
    } else {
      this.details.style.height = '';
    }

    this.details.style.overflow = '';
    this.content.style.opacity = '';
  };

  var allContainers = [];

  document.querySelectorAll('.spm-bundled-products').forEach(function (container) {
    enforceConsistentQtyLayout(container);

    var group = [];
    container.querySelectorAll('.spm-bundle-item').forEach(function (el) {
      group.push(new SpmBundleAccordion(el, group));
    });

    allContainers.push({ container: container, group: group });
  });

  var resizeTimeout = null;
  window.addEventListener('resize', function () {
    if (resizeTimeout) clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      allContainers.forEach(function (entry) {
        enforceConsistentQtyLayout(entry.container);

        entry.group.forEach(function (instance) {
          instance.measure();

          // If this item is currently open (and not mid-animation), snap its
          // height to match the freshly-measured content, since the old cached
          // height may no longer be correct at the new viewport width.
          if (instance.details.open && !instance.isClosing && !instance.isExpanding) {
            var openHeight = Math.max(
              instance.summary.offsetHeight,
              instance.contentTop + instance.content.offsetHeight
            );
            instance.details.style.height = openHeight + 'px';
          }
        });
      });
    }, 150);
  });
})();